<template>
  <div id="app" class="upheavel-pro">
    <mobile-sidebar :eggsBalance=eggsBalance :sideBar=sideBar @openSidebar=openSidebar @connect=connect() @disconnect="disconnect()" :connected="walletConnected" :connectedAccount="MetaMaskAddress" />
    <desktop-side-bar :desktopSideBar=desktopSideBar @openDesktopSidebar=openDesktopSidebar></desktop-side-bar>
    <div class="bg-image" :class="getClass()">
      <div id="nav">
        <topbar @connect=connect() @disconnect="disconnect()" :desktopSideBar=desktopSideBar :connected="walletConnected" :eggsBalance=eggsBalance :connectedAccount="MetaMaskAddress" @openDesktopSidebar=openDesktopSidebar :mobile="false" class="d-none d-md-flex" />
        <topbar @connect=connect() @disconnect="disconnect()" :connected="walletConnected" :connectedAccount="MetaMaskAddress" @openDesktopSidebar=openDesktopSidebar @openSidebar=openSidebar :mobile="true" class="d-md-none d-flex" />
      </div>
      <div @click="closeSidebar()"  :class="getClass()">
        <router-view @connect="connect"
          @openToast="openToast"
          @eggsBalance="getEggsBalance"
          :eggsBalance="eggsBalance"
          :walletConnected="walletConnected"
          :connectButtonText="connectButtonText" class="keep-alive"
        />
      </div>
    </div>
  </div>
</template>
<script>
import topbar from './components/TopBar.vue'
import MobileSidebar from './components/MobileSidebar.vue'
import DesktopSideBar from './components/DesktopSideBar.vue'
import conf from "./conf";

export default {
  data(){
    return{
      toastCount:0,
      disconnectRequest:false,
      sideBar: false,
      desktopSideBar: false,
      connected: false,
      eggsBalance:"0",
      walletConnected: false,
      networkChangeRequested: false,
      MetaMaskId: "1", // main net netID
      netID: "1", // user metamask id
      MetaMaskAddress: "", // user Address
      connectButtonText: "Connect Wallet",
      type: "INIT",
      MetamaskMsg: {
          LOAD_METAMASK_WALLET_ERROR: "Loading metamask error, please try later",
          EMPTY_METAMASK_ACCOUNT:
          "Please log in to your metamask to continue with this app.",
          NETWORK_ERROR: "The connection is abnormal, please try again",
          METAMASK_NOT_INSTALL: "Please install metamask for this application",
          METAMASK_TEST_NET: "Currently not in the main network.",
          METAMASK_MAIN_NET: "Currently Main network",
          USER_DENIED_ACCOUNT_AUTHORIZATION: "User denied account authorization",
      },
      networks: {
          137: {name: "POLYGON", hex: "0x89"},
          80001: {name: "POLYGON_MUMBAI", hex: "0x13881"},
          5777: {name: "GANACHE", hex: "0x539"}
      }
        }
  },
  components:{
    topbar,
    MobileSidebar,
    DesktopSideBar
  },
  created () {
      let that = this
      ethereum.on('accountsChanged', function () {
      // Time to reload your interface with accounts[0]!
          window.location.reload()
      });

      ethereum.on('chainChanged', function () {
      // Time to reload your interface with accounts[0]!
          that.networkChanged()
      });
      console.log("NETLIFY CONFIG TEST:", process.env.VUE_APP_Coop)
  },
  mounted() {
      const isMetaMaskInstalled = () => {
            // Have to check the ethereum binding on the window object to see if it's installed
            const { ethereum } = window;
            return Boolean(ethereum && ethereum.isMetaMask);
        };
        
        if (!isMetaMaskInstalled() && !ethereum.isConnected()) {
            this.connectButtonText = "Install Metamask"
            this.Log(this.MetamaskMsg.METAMASK_NOT_INSTALL, "NO_INSTALL_METAMASK");
            console.error(
                "Non-Ethereum browser detected. You should consider trying MetaMask!"
            );
        }
        else {
            // user needs to connect wallet
            this.checkItsAlreadyConnected()
        }
        this.checkAccounts()
  },
  updated(){
    if(this.disconnectRequest == false){
      this.checkAccounts()
    }
      
  },
  methods: {
    openToast({variant , message}){
        const h = this.$createElement
        const id = 'my-toast-'+`${this.toastCount++}`
        // Create the message
        const vNodesMsg = h(
          'p',
          { class: ['text-center', 'mb-0' , 'cursor-pointer']  , on: { click: () => this.$bvToast.hide(id) }},
          [
            ` ${message} `,
          ]
        )
        // Pass the VNodes as an array for message and title
        this.$bvToast.toast([vNodesMsg], {
          id: id,
          noCloseButton:true,
          solid: true,
          toaster: 'b-toaster-top-center',
          variant: `${variant}`
        })
    },
    getEggsBalance(value){
      this.eggsBalance = value
    },
    openSidebar(value){
      this.sideBar = value
    },
    closeSidebar(){
      this.sideBar = false
      this.desktopSideBar= false
    },
    checkAccounts(){
      if (ethereum.selectedAddress === null) {
                this.MetaMaskAddress = "";
                this.walletConnected = false
                this.Log(this.MetamaskMsg.EMPTY_METAMASK_ACCOUNT, "NO_LOGIN");
                return;
            }else {
                this.MetaMaskAddress = ethereum.selectedAddress;
                this.walletConnected = true
            }
    },
    async networkChanged() {
        try {
            let chainId = ethereum.chainId
            // console.log([conf.DEFAULT_NETWORK.hex, chainId])
            if (chainId !== conf.DEFAULT_NETWORK.hex){
                this.openToast({variant: 'danger' , message: "Please use MATIC MAINNET"})
                // console.log(`RETURN TO DEFAULT NETWORK ! ${chainId}`)
                if (!this.networkChangeRequested){
                    try {
                        // await ethereum.request({
                        //     method: 'wallet_switchEthereumChain',
                        //     params: [{ chainId: conf.DEFAULT_NETWORK.hex }],
                        // });
                    } catch (switchError) {
                        if (switchError.code === 4902) {
                            console.log("This error code indicates that the chain has not been added to MetaMask.")
                            this.$emit('openToast' , {variant: 'danger' , message:error.message})
                        }
                        // handle other "switch" errors
                    }

                    this.networkChangeRequested = true
                }
            } else {
                if (this.MetaMaskAddress !== ""){
                    return this.Log(this.MetamaskMsg.METAMASK_TEST_NET, this.networks[netId].name);
                }
            }
        } catch (err) {
            this.openToast({variant: 'danger' , message: "Please use MATIC MAINNET"})
            this.Log(this.MetamaskMsg.NETWORK_ERROR, "NETWORK_ERROR");
        }
    },
    Log(msg, type = "") {
        const letType = type;
        if (letType === this.type) return;
        const message = this.userMessage === "null" ? msg : this.userMessage;
        this.type = type;
    },
    checkItsAlreadyConnected(){
        this.walletConnected = ethereum.selectedAddress !== null
    },
    connect (){
      if(ethereum.selectedAddress == null)
        ethereum
        .request({ method: 'eth_requestAccounts' })
        .then((accounts) => {
          this.checkAccounts(accounts)
          this.disconnectRequest = false
          this.reloadPage()
          }
        )
        .catch((error) => {
            if (error.code === 4001) {
                // EIP-1193 userRejectedRequest error
                console.log('Please connect to MetaMask.');
            } else {
                console.error(error);
            }
        });
        else{
          this.walletConnected=true
          this.MetaMaskAddress=ethereum.selectedAddress
          this.disconnectRequest = true
        }
    },
    reloadPage(){
      window.location.reload()
    },
    disconnect() {
        // there is no direct way to remove account permission from MetaMask
        // we only can drop session.
        // user must remove by hand
        this.walletConnected=false
        this.MetaMaskAddress=""
        this.disconnectRequest= true
    },
    getClass(){
      if(this.sideBar)
        return 'opacity-on'
      return 'opacity-off'
    },
    openDesktopSidebar(value){
      this.desktopSideBar = value
    }

  }
}
</script>

<style>
.keep-alive{
  margin-top: 83px;
}
.cursor-pointer{
  cursor: pointer;
}
.b-toast:first-child{
  margin-top: 83px;
}
*:focus {
    outline: 0 !important;
}
body {
  min-height: 100%;
  width: 100%;
  background-image: url('./assets/images/Main-Screen-Background.webp');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}
body.gamedata {
  background-image: url('./assets/images/bilboard.webp');
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  background-attachment: fixed;
}
body.whitepaper-background{
  background-image: url('./assets/images/whitepaper-bg.webp');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: black;
  background-attachment: fixed;
}
.opacity-on{
  filter: brightness(50%)
}
.opacity-off{
  filter:none
}
#app{
  width: 100%;
  height: 100%;
  margin: 0;
}


#nav a {
  font-weight: normal;
  color: #fff;
  text-decoration: none;
}
#nav a:hover {
  color: #ffe371;
  transition: color .3s ease-in;
}

#nav a.router-link-active {
  color: #ffe371;
  text-decoration: none;
}
@media (max-width: 1600px) {
  body.gamedata{
    background-size: 100% 100%;
  }
}
@media (max-width: 770px) {
  .keep-alive{
    margin: 0px;
    color:white
  }
  .b-toast:first-child{
    margin-top: 0px;
  }
  body.gamedata {
    min-height: 100%;
    width: 100%;
    background-image: url('./assets/images/Main-Screen-Background.webp');
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    overflow: unset;
  }
  body.whitepaper-background{
    min-height: 100%;
    width: 100%;
    background-image: url('./assets/images/whitepaper-bg.webp');
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    overflow: unset;
}
}
</style>
